import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { combineLatest, map } from 'rxjs';

export interface SnapScrollerPage {
  position: number;
  els: HTMLElement[];
}

interface SnapScrollerDirectiveState {
  index: number;
  width?: number;
  height?: number;
  pages: SnapScrollerPage[];

  enabled: boolean;
}

@Injectable()
export class SnapScrollerStore extends ComponentStore<SnapScrollerDirectiveState> {
  vm$ = this.select((s) => s);
  pageCount$ = this.select((s) => s.pages?.length ?? 0);
  index$ = this.select((s) => s.index);
  pages$ = this.select((s) => s.pages);
  canPrevious$ = this.index$.pipe(map((index) => index > 0));
  canNext$ = combineLatest([this.index$, this.pageCount$]).pipe(
    map(([index, pageCount]) => index < pageCount - 1)
  );

  enabled$ = this.select((s) => s.enabled);

  currentPage$ = combineLatest([this.index$, this.pages$]).pipe(
    map(([index, pages]) => {
      return pages[index];
    })
  );

  constructor() {
    super({ index: 0, pages: [], enabled: false });
  }

  goToIndex(index: number) {
    this.patchState({ index });
  }

  previous() {
    const currentIndex = this.index;
    const previousIndex = Math.max(0, currentIndex - 1);
    console.log({ currentIndex });
    console.log({ previousIndex });
    this.patchState({ index: previousIndex });
  }

  next() {
    const currentIndex = this.index;
    const maxIndex = this.pageCount - 1;
    const nextIndex = Math.min(maxIndex, currentIndex + 1);
    this.patchState({ index: nextIndex });
  }

  enable() {
    this.patchState({ enabled: true });
  }

  disable() {
    this.patchState({ enabled: false });
  }

  get index(): number {
    return this.get((s) => s.index);
  }

  get pageCount(): number {
    return this.get((s) => s.pages?.length ?? 0);
  }
}
